module.exports = {
          srcSet: __webpack_public_path__ + "c343b70220c39f659ffd5603e243e600-1920.png"+" 1920w",
          images:[ {path: __webpack_public_path__ + "c343b70220c39f659ffd5603e243e600-1920.png",width: 1920,height: 563}],
          src: __webpack_public_path__ + "c343b70220c39f659ffd5603e243e600-1920.png",
          toString:function(){return __webpack_public_path__ + "c343b70220c39f659ffd5603e243e600-1920.png"},
          
          width: 1920,
          height: 563
        }